<template>
  <carousel
    v-bind="carouselProps"
    ref="carouselRef"
    class="v2-carousel"
    :class="[
      theme,
      paginationTheme ? `pagination-${paginationTheme}` : '',
      navigationTheme ? `navigation-${navigationTheme}` : '',
      navigationOuter ? 'navigation-outer' : '',
    ]"
    @slide-start="slideStart"
  >
    <slot />

    <template #addons>
      <div class="carousel-navigation">
        <navigation>
          <template #next>
            <i class="icon" :class="navigationOuter ? 'icon-arrow-right-thin' : 'icon-angle-right'" />
          </template>
          <template #prev>
            <i class="icon" :class="navigationOuter ? 'icon-arrow-left-thin' : 'icon-angle-left'" />
          </template>
        </navigation>
      </div>
      <app-carousel-pagination :current="currentSlide" :count="maxSlide" @pagination-click="slideTo" />
    </template>
  </carousel>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, useAttrs } from "vue";
import { Carousel, Navigation } from "vue3-carousel";
import AppCarouselPagination from "@/components/v2/app-carousel-pagination/index.vue";

defineOptions({
  name: "app-carousel",
});

defineProps({
  theme: {
    type: String,
    required: false,
    default: null,
    validator: (value: string) => {
      return ["light", "dark", null].includes(value);
    },
  },
  paginationTheme: {
    type: String,
    required: false,
    default: null,
    validator: (value: string) => {
      return ["light", "dark", null].includes(value);
    },
  },
  navigationTheme: {
    type: String,
    required: false,
    default: null,
    validator: (value: string) => {
      return ["light", "dark", null].includes(value);
    },
  },
  navigationOuter: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["pageChange"]);
const attrs = useAttrs();
const carouselRef = ref<any>(null);
const currentSlide = ref(0);
const maxSlide = ref(0);

const carouselProps = computed(() => {
  return {
    ...{ itemsToShow: 1, snapAlign: "start" as const },
    ...attrs,
  };
});

const slideStart = (params: Record<string, any>) => {
  maxSlide.value = params.slidesCount;
  currentSlide.value = params.slidingToIndex;
  emit("pageChange", params);
};

const slideTo = (index: number) => {
  carouselRef.value?.slideTo(index);
};

function next() {
  carouselRef.value?.next();
}

function prev() {
  carouselRef.value?.prev();
}

defineExpose({ next, prev, slideTo });

onMounted(() => {
  // fix ios 17 bug with render
  window.dispatchEvent(new Event("resize"));

  setTimeout(() => {
    if (carouselRef.value) {
      carouselRef.value.updateSlidesData();
      maxSlide.value = carouselRef.value.data.maxSlide.value + 1;
    }
  }, 500);
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
